import Grid from '@material-ui/core/Grid';
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { reduxForm, Field, Form } from 'redux-form/immutable';
import { List } from 'immutable';

import { showDialog, hideDialog, showWarning } from '../../../redux/actions/dialogs';
import { renderJobProfileDrilldown } from '../../../utils/reduxforms';
import { fetchJobProfilesRoutine } from '../../../redux/routines';

import { toJS } from '../../../utils/helper';
import { required } from '../../../utils/formvalidation';
import validate from './validate';
import { CREATE_JOB_DIALOG } from '../../../redux/constants/dialogs';

class Page2 extends React.Component {
  state = {};

  componentWillMount() {
    this.props.fetchJobProfiles();
  }

  render() {
    const { handleSubmit, jobProfiles } = this.props;
    return (
      <Form onSubmit={handleSubmit}>
        <Grid container spacing={8}>
          <Grid item xs={12}>
            <Field
              name="profile"
              component={renderJobProfileDrilldown}
              validation={required}
              jobProfiles={jobProfiles || []}
              validate={required}
            />
          </Grid>
        </Grid>
      </Form>
    );
  }
}

Page2.propTypes = {
  jobProfiles: PropTypes.array,
  roles: PropTypes.array,
  showDialog: PropTypes.func.isRequired,
  hideDialog: PropTypes.func.isRequired,
  showWarning: PropTypes.func.isRequired,
};

const form = reduxForm({
  form: CREATE_JOB_DIALOG, // <------ same form name
  destroyOnUnmount: false, // <------ preserve form data
  forceUnregisterOnUnmount: true, // <------ unregister fields on unmount
  // validate,
})(Page2);

function mapStateToProps(state) {
  return {
    roles: toJS(state.getIn(['roles', 'roles', 'data'])),
    jobProfiles: toJS(state.getIn(['jobprofiles', 'jobProfiles', 'data'])),
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    showDialog,
    hideDialog,
    showWarning,
    fetchJobProfiles: fetchJobProfilesRoutine.trigger,
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(form);



// WEBPACK FOOTER //
// ./src/components/Jobs/CreateJobDialog/Page2.js